/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ billed: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Summary_Billed_OfInputs */



/**
* | output |
* | --- |
* | "{billed} of {total} customers billed" |
*
* @param {Partner_Summary_Billed_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_billed_of = /** @type {((inputs: Partner_Summary_Billed_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_Billed_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.billed} von ${i?.total} Kunden abgerechnet`)
	return /** @type {LocalizedString} */ (`${i?.billed} of ${i?.total} customers billed`)
});